module.exports = __webpack_public_path__ + "img/fi-rr-delete.8f684d7f.svg";